export const color = [
  '#6B88FF',
  '#5EB2FC',
  '#3FD2E0',
  '#5FE1A4',
  '#C7E677',
  '#FCD55E',
  '#FCB35E',
  '#FC985E',
  '#FC7272',
  '#F45A9A',
  '#DA5EFC',
  '#B45EFC',
  '#956EFC'
]
